angular.module('shared').directive('dateInput', ["$timeout", function($timeout) {
  return {
    restrict: 'E',
    template: require('templates/shared/date_input.html.slim'),
    scope: {
      model: '=',
      dropdown: '=',
      minDate: '=',
      maxDate: '=',
      allowRemove: '=',
      isDisabled: '=',
      alwaysOpen: '=',
      inputSm: '=',
      isSm: '=',
      compact: '=',
      fullWidth: '=',
      appendToBody: '=',
      name: '@',
      placeholder: '@',
      elementId: '@',
      modelFormat: '@',
      displayFormat: '@',
      mode: '@',
      position: '@',
      onChange: '&',
      variant: '@',
      newIcon: '=',
      clearWithNull: '='
    },
    controller: ["$scope", function($scope) {
      $scope.model_format = $scope.modelFormat || 'YYYY-MM-DD';
      $scope.display_format = $scope.displayFormat || 'dd MMM yyyy';
      if ($scope.alwaysOpen) {
        $scope.isOpen = true;
      }
      $scope.id = Math.floor(Math.random() * 10000);
      $scope.onDateChanged = function() {
        return $timeout(function() {
          $scope.onDateClick();
          return $scope.onChange();
        });
      };
      return $scope.remove = function(event) {
        event.preventDefault();
        event.stopPropagation();
        $scope.model = $scope.clearWithNull ? null : void 0;
        return $scope.onDateChanged();
      };
    }],
    link: function($scope, element) {
      var pxToInteger;
      pxToInteger = function(val) {
        return +(val.replace('px', ''));
      };
      $scope.isTop = function() {
        var inputPositions;
        inputPositions = element[0].getBoundingClientRect();
        return $scope.position === 'top' || (inputPositions.bottom + 320 > window.innerHeight && inputPositions.top > 320);
      };
      $scope.onDateClick = function() {
        return element.find('input').blur();
      };
      return $scope.toggle = function(event) {
        if (!($scope.isDisabled || $scope.alwaysOpen)) {
          $scope.isOpen = !$scope.isOpen;
        }
        if ($scope.isOpen) {
          if ($scope.appendToBody) {
            $timeout(function() {
              return angular.element('[datepicker-popup-wrap]').each(function(index, item) {
                var newTop, positions;
                positions = item.getBoundingClientRect();
                if (positions.width && positions.width + positions.left > window.innerWidth) {
                  angular.element(item).css({
                    right: 0,
                    left: 'unset'
                  });
                }
                if (positions.bottom > window.innerHeight) {
                  newTop = pxToInteger(angular.element(item).css('top')) - 245;
                  return angular.element(item).css({
                    top: newTop
                  });
                }
              });
            });
          } else {
            $timeout(function() {
              var diff, inputPositions, popup, popupPositions, ref;
              inputPositions = element[0].getBoundingClientRect();
              popup = element.find('[datepicker-popup-wrap]');
              popupPositions = (ref = popup[0]) != null ? ref.getBoundingClientRect() : void 0;
              if ((popupPositions != null ? popupPositions.width : void 0) && popupPositions.width + popupPositions.left > window.innerWidth) {
                diff = window.innerWidth - (popupPositions.width + inputPositions.left);
                return popup.css({
                  left: diff
                });
              }
            });
          }
        }
        event.preventDefault();
        return event.stopPropagation();
      };
    }
  };
}]);
